import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { ASPECT_RATIOS, AspectRatioKey } from 'components/NewFileModal/Types'
import { DesignAspectRatio } from 'types'
import { TextChannels } from '../../../../constants'

interface Channel extends Partial<DesignAspectRatio> {
  type: ChannelType | AspectRatioKey | GenerationType
  name: string
  icon: any
  tags: Array<string>
  enabledForCampaign?: boolean
}

export interface Category {
  title: string
  channels: Array<Channel>
  categories?: Array<Category>
}

// TODO - Items that are commented out, currently do not allow turn into.
// Once they are are properly implemented, they can be uncommented.
export const categoriesWithDesignChannels: Array<Category> = [
  {
    title: 'Popular',
    channels: [
      { type: ChannelType.LinkedInPosts, ...TextChannels[ChannelType.LinkedInPosts] },
      {
        type: 'linkedin-post',
        ...ASPECT_RATIOS['linkedin-post'],
        tags: ['social', 'media', 'linkedin', 'post', 'linkedin post'],
      },
      {
        type: ChannelType.BlogPost,
        ...TextChannels[ChannelType.BlogPost],
      },
      {
        type: 'instagram-portrait-post',
        ...ASPECT_RATIOS['instagram-portrait-post'],
        tags: ['social', 'media', 'instagram', 'post', 'instagram post'],
      },
      {
        type: 'facebook-post',
        ...ASPECT_RATIOS['facebook-post'],
        tags: ['social', 'media', 'facebook', 'post', 'facebook post'],
      },
      { type: ChannelType.GoogleAds, ...TextChannels[ChannelType.GoogleAds] },
      { type: ChannelType.FacebookAds, ...TextChannels[ChannelType.FacebookAds] },
      { type: ChannelType.TweetThread, ...TextChannels[ChannelType.TweetThread] },
      // { type: 'pinterest', ...ASPECT_RATIOS['pinterest'], tags: ['pinterest', 'social', 'media'] },
    ],
  },
  {
    title: 'Social Media',
    channels: [],
    categories: [
      {
        title: 'LinkedIn',
        channels: [
          {
            type: GenerationType.LinkedInPlanning,
            ...TextChannels[GenerationType.LinkedInPlanning],
            enabledForCampaign: false,
          },
          { type: ChannelType.LinkedInPosts, ...TextChannels[ChannelType.LinkedInPosts] },
          {
            type: 'linkedin-post',
            ...ASPECT_RATIOS['linkedin-post'],
            tags: ['social', 'media', 'linkedin', 'post', 'linkedin post'],
          },
          {
            type: 'linkedin-profile-picture',
            ...ASPECT_RATIOS['linkedin-profile-picture'],
            tags: ['social', 'media', 'linkedin', 'profile', 'picture', 'linkedin profile picture'],
          },
          {
            type: 'linkedin-banner',
            ...ASPECT_RATIOS['linkedin-banner'],
            tags: ['social', 'media', 'linkedin', 'banner', 'linkedin banner'],
          },
          { type: ChannelType.LinkedInAds, ...TextChannels[ChannelType.LinkedInAds] },
        ],
      },
      {
        title: 'Instagram',
        channels: [
          {
            type: GenerationType.InstagramPlanning,
            ...TextChannels[GenerationType.InstagramPlanning],
            enabledForCampaign: false,
          },
          {
            type: 'instagram-square-post',
            ...ASPECT_RATIOS['instagram-square-post'],
            tags: ['social', 'media', 'instagram', 'post', 'instagram post'],
          },
          {
            type: 'instagram-reel',
            ...ASPECT_RATIOS['instagram-reel'],
            tags: ['social', 'media', 'instagram', 'reel', 'instagram reel'],
          },
          {
            type: 'instagram-story',
            ...ASPECT_RATIOS['instagram-story'],
            tags: ['social', 'media', 'instagram', 'post', 'instagram post'],
          },
          {
            type: 'instagram-portrait-post',
            ...ASPECT_RATIOS['instagram-portrait-post'],
            tags: ['social', 'media', 'instagram', 'post', 'instagram post'],
          },
          {
            type: 'instagram-landscape-post',
            ...ASPECT_RATIOS['instagram-landscape-post'],
            tags: ['social', 'media', 'instagram', 'post', 'instagram post'],
          },
          { type: ChannelType.InstagramPosts, ...TextChannels[ChannelType.InstagramPosts] },
          { type: ChannelType.InstagramReel, ...TextChannels[ChannelType.InstagramReel] },
        ],
      },
      {
        title: 'Facebook',
        channels: [
          {
            type: GenerationType.FacebookPlanning,
            ...TextChannels[GenerationType.FacebookPlanning],
            enabledForCampaign: false,
          },
          {
            type: 'facebook-post',
            ...ASPECT_RATIOS['facebook-post'],
            tags: ['social', 'media', 'facebook', 'post', 'facebook post'],
          },
          { type: ChannelType.FacebookPost, ...TextChannels[ChannelType.FacebookPost] },
          // {
          //   type: 'facebook-marketplace',
          //   ...ASPECT_RATIOS['facebook-marketplace'],
          //   tags: ['social', 'media', 'facebook', 'post', 'marketplace'],
          // },
          {
            type: 'facebook-cover',
            ...ASPECT_RATIOS['facebook-cover'],
            tags: ['social', 'media', 'facebook', 'post', 'facebook post'],
          },
          { type: ChannelType.FacebookAds, ...TextChannels[ChannelType.FacebookAds] },
          {
            type: 'facebook-profile-picture',
            ...ASPECT_RATIOS['facebook-profile-picture'],
            tags: ['social', 'media', 'facebook', 'profile', 'picture', 'facebook profile picture'],
          },
        ],
      },
      {
        title: 'X/Twitter',
        channels: [
          {
            type: GenerationType.TwitterPlanning,
            ...TextChannels[GenerationType.TwitterPlanning],
            enabledForCampaign: false,
          },
          { type: ChannelType.Tweets, ...TextChannels[ChannelType.Tweets] },
          { type: ChannelType.TweetThread, ...TextChannels[ChannelType.TweetThread] },
          {
            type: 'twitter-post',
            ...ASPECT_RATIOS['twitter-post'],
            tags: ['social', 'media', 'x', 'twitter', 'post', 'tweet', 'x post'],
          },
          {
            type: 'twitter-profile-picture',
            ...ASPECT_RATIOS['twitter-profile-picture'],
            tags: ['social', 'media', 'x', 'twitter', 'profile', 'picture', 'tweet', 'x profile picture'],
          },
          {
            type: 'twitter-cover-image',
            ...ASPECT_RATIOS['twitter-cover-image'],
            tags: ['social', 'media', 'x', 'twitter', 'cover', 'image', 'tweet', 'x cover image'],
          },
        ],
      },
      {
        title: 'TikTok',
        channels: [
          { type: 'tik-tok-post', ...ASPECT_RATIOS['tik-tok-post'], tags: ['tik', 'tok', 'post', 'social', 'media'] },
          { type: ChannelType.TikTokScript, ...TextChannels[ChannelType.TikTokScript] },
          {
            type: 'tik-tok-thumbnail',
            ...ASPECT_RATIOS['tik-tok-thumbnail'],
            tags: ['tik', 'tok', 'post', 'social', 'media', 'thumbnail'],
          },
          { type: ChannelType.TikTokAds, ...TextChannels[ChannelType.TikTokAds] },
        ],
      },
      {
        title: 'YouTube',
        channels: [
          { type: ChannelType.YoutubeScript, ...TextChannels[ChannelType.YoutubeScript] },
          {
            type: 'youtube-channel-art',
            ...ASPECT_RATIOS['youtube-channel-art'],
            tags: ['youtube', 'channel', 'art', 'channel art', 'cover', 'thumbnail'],
          },
          {
            type: 'youtube-profile-picture',
            ...ASPECT_RATIOS['youtube-profile-picture'],
            tags: ['youtube', 'channel', 'profile', 'picture', 'profile picture'],
          },
          { type: ChannelType.YoutubeAds, ...TextChannels[ChannelType.YoutubeAds] },
        ],
      },
      {
        title: 'Pinterest',
        channels: [
          // { type: 'pinterest', ...ASPECT_RATIOS['pinterest'], tags: ['pinterest', 'social', 'media'] },
          { type: ChannelType.PinterestAds, ...TextChannels[ChannelType.PinterestAds] },
        ],
      },
      // {
      //   title: 'WhatsApp',
      //   channels: [
      //     {
      //       type: 'whatsapp-sticker',
      //       ...ASPECT_RATIOS['whatsapp-sticker'],
      //       tags: ['whatsapp', 'sticker', 'social', 'media'],
      //     },
      //   ],
      // },
    ],
  },
  {
    title: 'Blog/SEO',
    channels: [
      { type: ChannelType.BlogPost, ...TextChannels[ChannelType.BlogPost] },
      { type: ChannelType.BlogIdeas, ...TextChannels[ChannelType.BlogIdeas] },
      { type: GenerationType.Outline, ...TextChannels[GenerationType.Outline] },
      { type: GenerationType.ContentBrief, ...TextChannels[GenerationType.ContentBrief] },
      { type: ChannelType.CaseStudy, ...TextChannels[ChannelType.CaseStudy] },
      { type: ChannelType.PressRelease, ...TextChannels[ChannelType.PressRelease] },
    ],
  },
  {
    title: 'Marketplace',
    channels: [
      { type: ChannelType.ProductLaunchWebsite, ...TextChannels[ChannelType.ProductLaunchWebsite] },
      { type: ChannelType.ProductLaunchGoogle, ...TextChannels[ChannelType.ProductLaunchGoogle] },
      // {
      //   type: 'facebook-marketplace',
      //   ...ASPECT_RATIOS['facebook-marketplace'],
      //   tags: ['social', 'media', 'facebook', 'post', 'marketplace'],
      // },
      // { type: 'ebay', ...ASPECT_RATIOS['ebay'], tags: ['marketplace', 'ebay'] },
      // { type: 'poshmark', ...ASPECT_RATIOS['poshmark'], tags: ['marketplace', 'poshmark'] },
      // { type: 'depop', ...ASPECT_RATIOS['depop'], tags: ['marketplace', 'depop'] },
      // { type: 'mercari', ...ASPECT_RATIOS['mercari'], tags: ['marketplace', 'mercari'] },
      // { type: 'mercadolibre', ...ASPECT_RATIOS['mercadolibre'], tags: ['marketplace', 'mercadolibre'] },
      // { type: 'shopee', ...ASPECT_RATIOS['shopee'], tags: ['marketplace', 'shopee'] },
      // { type: 'lazada', ...ASPECT_RATIOS['lazada'], tags: ['marketplace', 'lazada'] },
      { type: ChannelType.ProductLaunchEtsy, ...TextChannels[ChannelType.ProductLaunchEtsy] },
      // { type: 'etsy', ...ASPECT_RATIOS['etsy'], tags: ['marketplace', 'etsy'] },
      // { type: 'vinted', ...ASPECT_RATIOS['vinted'], tags: ['marketplace', 'vinted'] },
      { type: ChannelType.ProductLaunchAmazon, ...TextChannels[ChannelType.ProductLaunchAmazon] },
      // { type: 'amazon', ...ASPECT_RATIOS['amazon'], tags: ['marketplace', 'amazon'] },
      { type: ChannelType.ProductLaunchShopify, ...TextChannels[ChannelType.ProductLaunchShopify] },
      // { type: 'shopify-square', ...ASPECT_RATIOS['shopify-square'], tags: ['marketplace', 'shopify-square'] },
      // { type: 'pinterest', ...ASPECT_RATIOS['pinterest'], tags: ['marketplace', 'pinterest'] },
    ],
  },
  {
    title: 'Product Descriptions',
    channels: [
      { type: ChannelType.ProductLaunchEtsy, ...TextChannels[ChannelType.ProductLaunchEtsy] },
      { type: ChannelType.ProductLaunchAmazon, ...TextChannels[ChannelType.ProductLaunchAmazon] },
      { type: ChannelType.ProductLaunchGoogle, ...TextChannels[ChannelType.ProductLaunchGoogle] },
      { type: ChannelType.ProductLaunchShopify, ...TextChannels[ChannelType.ProductLaunchShopify] },
    ],
  },

  {
    title: 'Video',
    channels: [
      { type: ChannelType.InstagramReel, ...TextChannels[ChannelType.InstagramReel] },
      {
        type: 'instagram-story',
        ...ASPECT_RATIOS['instagram-story'],
        tags: ['social', 'media', 'instagram', 'post', 'story'],
      },
      { type: ChannelType.YoutubeScript, ...TextChannels[ChannelType.YoutubeScript] },
      // {
      //   type: 'youtube-channel-art',
      //   ...ASPECT_RATIOS['youtube-channel-art'],
      //   tags: ['youtube', 'thumbnail'],
      // },
      { type: ChannelType.TikTokScript, ...TextChannels[ChannelType.TikTokScript] },
      {
        type: 'tik-tok-post',
        ...ASPECT_RATIOS['tik-tok-post'],
        tags: ['tik', 'tok', 'post', 'social', 'media'],
      },
      // {
      //   type: 'tik-tok-thumbnail',
      //   ...ASPECT_RATIOS['tik-tok-thumbnail'],
      //   tags: ['tik', 'tok', 'post', 'social', 'media', 'thumbnail'],
      // },
    ],
  },
  {
    title: 'Ads',
    channels: [
      { type: ChannelType.AmazonAds, ...TextChannels[ChannelType.AmazonAds] },
      { type: ChannelType.BingAds, ...TextChannels[ChannelType.BingAds] },
      { type: ChannelType.GoogleAds, ...TextChannels[ChannelType.GoogleAds] },
      { type: ChannelType.FacebookAds, ...TextChannels[ChannelType.FacebookAds] },
      { type: ChannelType.LinkedInAds, ...TextChannels[ChannelType.LinkedInAds] },
      { type: ChannelType.PinterestAds, ...TextChannels[ChannelType.PinterestAds] },
      { type: ChannelType.TikTokAds, ...TextChannels[ChannelType.TikTokAds] },
      { type: ChannelType.YoutubeAds, ...TextChannels[ChannelType.YoutubeAds] },
    ],
  },
  {
    title: 'Emails',
    channels: [
      { type: ChannelType.PromotionalEmailSequence, ...TextChannels[ChannelType.PromotionalEmailSequence] },
      { type: ChannelType.ColdOutboundEmailSequence, ...TextChannels[ChannelType.ColdOutboundEmailSequence] },
      { type: ChannelType.WarmOutboundEmailSequence, ...TextChannels[ChannelType.WarmOutboundEmailSequence] },
      { type: ChannelType.SMSMessages, ...TextChannels[ChannelType.SMSMessages] },
      { type: ChannelType.Newsletter, ...TextChannels[ChannelType.Newsletter] },
      { type: ChannelType.NewsletterIdeas, ...TextChannels[ChannelType.NewsletterIdeas] },
      { type: ChannelType.NurtureEmailSequence, ...TextChannels[ChannelType.NurtureEmailSequence] },
      { type: ChannelType.WelcomeSeries, ...TextChannels[ChannelType.WelcomeSeries] },
      { type: ChannelType.DidntSignUp, ...TextChannels[ChannelType.DidntSignUp] },
      { type: ChannelType.AbandonedCart, ...TextChannels[ChannelType.AbandonedCart] },
      { type: ChannelType.LostCustomer, ...TextChannels[ChannelType.LostCustomer] },
    ],
  },
  {
    title: 'Website',
    channels: [
      { type: ChannelType.Mission, ...TextChannels[ChannelType.Mission] },
      { type: ChannelType.Impact, ...TextChannels[ChannelType.Impact] },
      { type: ChannelType.JobDescription, ...TextChannels[ChannelType.JobDescription] },
      { type: ChannelType.FAQs, ...TextChannels[ChannelType.FAQs] },
      { type: ChannelType.LandingPage, ...TextChannels[ChannelType.LandingPage] },
      { type: ChannelType.AboutUs, ...TextChannels[ChannelType.AboutUs] },
      { type: ChannelType.Pricing, ...TextChannels[ChannelType.Pricing] },
      { type: ChannelType.CandidateNurtureSequence, ...TextChannels[ChannelType.CandidateNurtureSequence] },
    ],
  },
  {
    title: 'Sales',
    channels: [
      { type: ChannelType.OnePager, ...TextChannels[ChannelType.OnePager] },
      { type: ChannelType.BattleCard, ...TextChannels[ChannelType.BattleCard] },
      { type: ChannelType.Testimonial, ...TextChannels[ChannelType.Testimonial] },
      { type: ChannelType.ProductDemo, ...TextChannels[ChannelType.ProductDemo] },
      { type: ChannelType.PreCallChecklist, ...TextChannels[ChannelType.PreCallChecklist] },
      { type: ChannelType.CallScript, ...TextChannels[ChannelType.CallScript] },
      { type: ChannelType.Research, ...TextChannels[ChannelType.Research] },
    ],
  },
  {
    title: 'Customer Support',
    channels: [
      { type: ChannelType.ReplyTemplates, ...TextChannels[ChannelType.ReplyTemplates] },
      { type: ChannelType.HelpDocs, ...TextChannels[ChannelType.HelpDocs] },
      { type: ChannelType.ReturnPolicy, ...TextChannels[ChannelType.ReturnPolicy] },
      { type: ChannelType.ShippingPolicy, ...TextChannels[ChannelType.ShippingPolicy] },
      { type: ChannelType.CareInstructions, ...TextChannels[ChannelType.CareInstructions] },
      { type: ChannelType.BillingAndPayments, ...TextChannels[ChannelType.BillingAndPayments] },
      { type: ChannelType.PaymentConfirmation, ...TextChannels[ChannelType.PaymentConfirmation] },
    ],
  },
  {
    title: 'Recruiting',
    channels: [
      { type: ChannelType.JobDescription, ...TextChannels[ChannelType.JobDescription] },
      { type: ChannelType.CandidateNurtureSequence, ...TextChannels[ChannelType.CandidateNurtureSequence] },
    ],
  },
]
